import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import NotFound from "#/src/pages/_components/NotFound";
import { getPathSection, isUnderPathPrefix } from "#/src/utils/pathPrefix";
import { logTutorEvent } from "#/src/utils/log";

// A /teachers 404 means an old link with no entry in the legacy /teachers redirect route.
const LOGGED_PREFIXES = ["/teachers", "/tutor"] as const;

/**
 * The router's fallback for URLs that match no page. Logs misses under /teachers and /tutor so a route
 * dropped while moving tutor pages shows up. Pages that render NotFound for missing data don't use this.
 */
export default function UnmatchedRoute() {
  const { pathname } = useLocation();

  // Keyed on pathname, not first render: moving from one unknown URL to another keeps this component mounted.
  useEffect(() => {
    const prefix = LOGGED_PREFIXES.find((p) => isUnderPathPrefix(pathname, p));
    if (!prefix) return;
    logTutorEvent({
      eventName: "tutor.marketplace.not_found",
      metadata: { prefix: prefix.slice(1), section: getPathSection(pathname, prefix) },
    });
  }, [pathname]);

  return <NotFound />;
}
